import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

interface Props {
  open: boolean;
  initial: string;
  title?: string;
  description?: string;
  saveLabel?: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

export function RenameDialog({
  open,
  initial,
  title = "Rename template",
  description = "How would you like to rename this template?",
  saveLabel = "Save",
  onClose,
  onSave,
}: Props) {
  const [name, setName] = useState(initial);
  useEffect(() => setName(initial), [initial, open]);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        <TextField
          fullWidth
          autoFocus
          margin="dense"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onSave(name)} disabled={!name.trim()}>
          {saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
